export enum ScreenKey {
  REPORTING_DASHBOARD = 'REPORTING_DASHBOARD',
  REPORTING_V2 = 'REPORTING_V2',
  CUSTOM_DASHBOARDS = 'CUSTOM_DASHBOARDS',
  REPORT_BUILDER = 'REPORT_BUILDER',
  PACING = 'PACING',
  FORECASTER = 'FORECASTER',
  CAMPAIGN_MANAGEMENT = 'CAMPAIGN_MANAGEMENT',
  CAMPAIGN_SUBMISSION = 'CAMPAIGN_SUBMISSION',
  CREATIVE_LIBRARY = 'CREATIVE_LIBRARY',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  WHITELABELS = 'WHITELABELS',
  FIRST_PARTY_DATA = 'FIRST_PARTY_DATA',
  CHANGE_LOG_HISTORY = 'CHANGE_LOG_HISTORY',

  CLIENTS = 'CLIENTS',
  AGENCIES = 'AGENCIES',
  ADVERTISERS = 'ADVERTISERS',

  PIXELS = 'PIXELS',
  SEGMENTS = 'SEGMENTS',

  CREATE_CAMPAIGN = 'CREATE_CAMPAIGN', // UI-only
  FORECASTER_TABLE = 'FORECASTER_TABLE', // UI-only
  FORECASTER_AI = 'FORECASTER_AI',
  SETTINGS = 'SETTINGS',
  INSIGHTS = 'INSIGHTS',

  PDF_BUILDER = 'PDF_BUILDER',

  /** SUPER_ADMIN-only ops screen (flank#4463) — reached directly, not through
   * the backend's per-account screens grant (see AppRouter's `alwaysAccessible`
   * for this route); the page itself checks `isSuperAdmin`. */
  PARTNER_DATA_HEALTH = 'PARTNER_DATA_HEALTH',
}

export default ScreenKey;
